/**
 * Drop new pieces in here to have them appear on /art.
 *
 * Add the file under src/assets/img/art/, import it, and push an entry:
 *   { id: "kinto", title: "Kinto", year: "2023", medium: "Procreate", image: kintoImg }
 *
 * The gallery renders an empty state on its own while this list is empty, so
 * the page is safe to ship before the images are in.
 */
const artwork = [];

export default artwork;
